import React from 'react';
import { Tooltip } from '@mui/material';
import CloudIcon from '@mui/icons-material/Cloud';
import ExploreIcon from '@mui/icons-material/Explore';
import RouteIcon from '@mui/icons-material/Route';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PlaceIcon from '@mui/icons-material/Place';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';
import { useTranslation } from 'react-i18next';

interface Props {
  active: Record<string, boolean>;
  onToggle: (key: string) => void;
  markingMode?: boolean;
  onToggleMarking?: () => void;
}

const BTN: React.CSSProperties = {
  width: 44, height: 44, background: 'transparent',
  border: 'none', cursor: 'pointer',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  transition: 'background 0.15s, color 0.15s',
  padding: 0,
};

const FeaturePanel: React.FC<Props> = ({
  active, onToggle,
  markingMode = false, onToggleMarking,
}) => {
  const { t } = useTranslation();

  const FEATURES = [
    { key: 'weather',   label: t('lifeCenter.featureWeather'),     icon: <CloudIcon />,    activeColor: '#4285f4' },
    { key: 'tourism',   label: t('lifeCenter.featureAttractions'), icon: <ExploreIcon />,  activeColor: '#4285f4' },
    { key: 'trip',      label: t('lifeCenter.featureTrips'),       icon: <RouteIcon />,    activeColor: '#9b59b6' },
    { key: 'health',    label: t('lifeCenter.featureHealth'),      icon: <FavoriteIcon />, activeColor: '#e91e63' },
    { key: 'locations', label: '地點',                             icon: <PlaceIcon />,    activeColor: '#ff6f00' },
  ];

  const locationsActive = !!active['locations'];
  const lastIdx = FEATURES.length - 1;

  return (
    <div style={{
      position: 'absolute', left: 20, top: 20, zIndex: 10,
      display: 'flex', flexDirection: 'column',
      background: 'rgba(15,25,50,0.82)',
      border: '1px solid rgba(66,133,244,0.35)',
      borderRadius: 8, overflow: 'visible',
      backdropFilter: 'blur(6px)',
    }}>
      {FEATURES.map((f, i) => {
        const isActive = !!active[f.key];
        const isLast   = i === lastIdx && !(f.key === 'locations' && locationsActive);
        return (
          <React.Fragment key={f.key}>
            <Tooltip title={f.label} placement="right" arrow>
              <button
                onClick={() => onToggle(f.key)}
                style={{
                  ...BTN,
                  background: isActive ? `${f.activeColor}33` : 'transparent',
                  color: isActive ? f.activeColor : 'rgba(255,255,255,0.7)',
                  borderBottom: isLast ? 'none' : '1px solid rgba(66,133,244,0.18)',
                  borderRadius: i === 0 ? '8px 8px 0 0' : isLast ? '0 0 8px 8px' : 0,
                }}
                onMouseEnter={e => {
                  if (!isActive) e.currentTarget.style.background = 'rgba(66,133,244,0.22)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = isActive ? `${f.activeColor}33` : 'transparent';
                }}
              >
                {f.icon}
              </button>
            </Tooltip>

            {f.key === 'locations' && locationsActive && (
              <Tooltip title={markingMode ? '關閉標記' : '啟動標記'} placement="right" arrow>
                <button
                  onClick={onToggleMarking}
                  style={{
                    ...BTN,
                    background: markingMode ? 'rgba(255,111,0,0.22)' : 'transparent',
                    color: markingMode ? '#ff6f00' : 'rgba(255,255,255,0.7)',
                    borderTop: '1px solid rgba(255,111,0,0.3)',
                    borderRadius: '0 0 8px 8px',
                  }}
                  onMouseEnter={e => {
                    if (!markingMode) e.currentTarget.style.background = 'rgba(255,111,0,0.18)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = markingMode ? 'rgba(255,111,0,0.22)' : 'transparent';
                  }}
                >
                  {markingMode ? <BookmarkAddedIcon /> : <BookmarkAddIcon />}
                </button>
              </Tooltip>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default FeaturePanel;
